export * from './types';

import type { LandingPageVariant, LandingPageContent } from './types';
import { DEFAULT_CONTENT } from './default';
import { TRADE_CONTENT } from './trade';
import { CASHFLOW_CONTENT } from './cashflow';
import { DAYTRADING_CONTENT } from './daytrading';

export const LANDING_PAGE_CONTENT: Record<LandingPageVariant, LandingPageContent> = {
  all: DEFAULT_CONTENT,
  trade: TRADE_CONTENT,
  cashflow: CASHFLOW_CONTENT,
  daytrading: DAYTRADING_CONTENT,
};

const VALID_VARIANTS: ReadonlyArray<LandingPageVariant> = ['trade', 'cashflow', 'daytrading'];

export function parseLandingVariant(paket: string | null): LandingPageVariant {
  if (paket === null) return 'all';
  const normalized = paket.trim().toLowerCase();
  if ((VALID_VARIANTS as ReadonlyArray<string>).includes(normalized)) {
    return normalized as LandingPageVariant;
  }
  return 'all';
}
